import { Col, Row, Image } from "antd";
import TestUI from "../TestUI";
import { PosturalExamination, PosturalTestDefinition } from "../interfaces";
import { TakenPhoto } from "../PosturalExamWrapper";
import "../../App.css";

const ComparePhotos = ({
  page,
  images,
  testDefinitions,
  posturalExamination,
  setTestSelection,
  reverse = false, // Se true, mette la foto a sinistra e le definizioni a destra
}: {
  page: number;
  images: TakenPhoto[];
  testDefinitions: PosturalTestDefinition[];
  posturalExamination: PosturalExamination;
  setTestSelection: Function;
  reverse?: boolean;
}) => {
  const sortedTestDefinitions = testDefinitions ? [...testDefinitions].sort((td1, td2) => td1.id - td2.id) : [];

  const photoDefinitionMapping = [
    { photoIndex: 0, definitionIndices: [0, 1, 2, 3] },
    { photoIndex: 1, definitionIndices: [4, 5, 6, 7] },
    { photoIndex: 2, definitionIndices: [8] },
    { photoIndex: 5, definitionIndices: [9] },
    { photoIndex: 6, definitionIndices: [10, 11] },
  ];

  const renderPhotoWithDefinitions = ({ photoIndex, definitionIndices }: { photoIndex: number; definitionIndices: number[] }) => {
    const definitionsForPhoto = definitionIndices.map(index => sortedTestDefinitions[index]);
    const photo = images[photoIndex];

    return (
      <Row key={photoIndex} style={{ marginBottom: "32px", alignItems: "center" }} gutter={16}>
        {/* Sezione foto */}
        <Col span={13} style={reverse ? { order: 1 } : { order: 0 }}>
          <Image
            src={photo?.url || ""}
            alt={`Foto ${photoIndex + 1}`}
            style={{ width: "100%", borderRadius: "8px" }}
          />
        </Col>

        {/* Sezione definizioni */}
        <Col span={11} style={reverse ? { order: 0 } : { order: 1 }}>
          {definitionsForPhoto.map((def, idx) => {
            const globalIndex = definitionIndices[idx];
            return (
              <TestUI
                key={globalIndex}
                testDefinition={def}
                testSelection={posturalExamination.testSelections?.[globalIndex]}
                setTestSelection={setTestSelection}
              />
            );
          })}
        </Col>
      </Row>
    );
  };

  return <>{page === 1 && photoDefinitionMapping.map(renderPhotoWithDefinitions)}</>;
};

export const CompareElicoidale = (props: any) => <ComparePhotos {...props} reverse={true} />;
export const CompareElicoidale2 = (props: any) => <ComparePhotos {...props} reverse={false} />;
